import Angular from "angular";
import Template from "./booking-state-icon.html";

export default Angular.module('booking-state-icon', [])
    .component('bookingStateIcon', {
        template: Template,
        bindings: {
            booking: '<',
            withLabel: '@'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/bookinst-state-icon/booking-state-icon.js